import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StreamProfile, StreamProfileTrackIncident } from '../../interfaces/streamProfile';

export interface StreamProfileState {
  profiles: StreamProfile[],
  incidents: StreamProfileTrackIncident[],
  loaded: boolean,
}

const initialState: StreamProfileState = {
  profiles: [],
  incidents: [],
  loaded: false,
};

export const streamProfileSlice = createSlice({
  name: 'streamProfile',
  initialState,
  reducers: {
    setStreamProfiles: (state, action: PayloadAction<{ profiles: StreamProfile[], incidents?: StreamProfileTrackIncident[] }>) => {
      const { profiles, incidents } = action.payload;
      state.profiles = profiles;
      if (incidents !== undefined) state.incidents = incidents;
      state.loaded = true;
    },
  },
});

export const { setStreamProfiles } = streamProfileSlice.actions;

export default streamProfileSlice.reducer;
